import { render, staticRenderFns } from "./shopping-cart.vue?vue&type=template&id=37c24031&scoped=true&"
import script from "./shopping-cart.vue?vue&type=script&lang=js&"
export * from "./shopping-cart.vue?vue&type=script&lang=js&"
import style0 from "../delivery-list.sass?vue&type=style&index=0&id=37c24031&scoped=true&lang=sass&"
import style1 from "./shopping-cart.vue?vue&type=style&index=1&id=37c24031&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c24031",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/goeatBackup/goeat-backup-goeat-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog,VFlex,VIcon,VLayout,VMenu,VSpacer})
